import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { FerramentaRouter } from '@components/ferramentas/FerramentaRouter.js'
import { barFillStyle } from '@utils/barStyle.js'
import { Button } from '@components/primitives/Button.js'

interface ChecklistItem {
  id: string
  texto: string
  concluido: boolean
}

interface Props {
  topicoId: string
  temFerramenta: boolean
  checklistItems: ChecklistItem[]
  percentualPratico: number
  onToggleChecklist: (id: string) => void
  onMarcarTodos: (marcar: boolean) => void
}

export function PassoObraApplySection({
  topicoId,
  temFerramenta,
  checklistItems,
  percentualPratico,
  onToggleChecklist,
  onMarcarTodos,
}: Props) {
  const showChecklist = checklistItems.length > 0

  if (!temFerramenta && !showChecklist) return null

  return (
    <>
      {temFerramenta && (
        <div className='cf3-block__card cf3-passo-obra__ferramenta'>
          <div className='cf3-passo-obra__head'>
            <h3 className='cf3-passo-obra__title'>Aplicar na sua obra</h3>
          </div>
          <FerramentaRouter topicoId={topicoId} persistKey={topicoId} />
        </div>
      )}

      {showChecklist && (
        <div className='cf3-block__card cf3-passo-obra__checklist'>
          <div className='cf3-passo-obra__checklist-head'>
            <div className='cf3-passo-obra__checklist-intro'>
              <h3 className='cf3-passo-obra__title'>Confirmei na minha obra</h3>
              <p className='cf3-passo-obra__desc'>
                Marque o que já verificou ou executou {GUIA_LABELS.nestaEtapa}.
              </p>
            </div>
            <div className='cf3-passo-obra__checklist-meta'>
              <span className='cf3-passo-obra__pct' aria-live='polite'>
                {percentualPratico}%
              </span>
              <Button
                variant='secondary'
                size='sm'
                className='cf-btn--inline'
                onClick={() => onMarcarTodos(percentualPratico < 100)}
              >
                {percentualPratico === 100 ? 'Desmarcar todos' : 'Marcar todos'}
              </Button>
            </div>
          </div>
          <div
            className='cf3-checklist-bar cf3-passo-obra__bar'
            role='progressbar'
            aria-valuenow={percentualPratico}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className='cf3-checklist-bar__fill' style={barFillStyle(percentualPratico)} />
          </div>
          <ul className='cf3-checklist-list'>
            {checklistItems.map((item) => (
              <li key={item.id} className='cf3-checklist-item'>
                <label className='cf3-checklist-item__label'>
                  <input
                    type='checkbox'
                    checked={item.concluido}
                    onChange={() => onToggleChecklist(item.id)}
                  />
                  <span
                    className={
                      item.concluido
                        ? 'cf3-checklist-item__texto cf3-checklist-item__texto--done'
                        : 'cf3-checklist-item__texto'
                    }
                  >
                    {item.texto}
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
